/* eslint-disable react-hooks/exhaustive-deps */
import App from '../../layout/App';
import {
  FormContent, Container, Message,
  BoxInput, Box50, Box,
  Box2Items, Select, Option,
  TitleFieldForm, TextLabel, Madatory,
  BoxColunm,
  Label,
} from '../../styles/styles'
import { useNavigate } from 'react-router';
import InputResponsive1 from '../../Components/InputResponsive1';
import Button from '../../Components/button';
import Checkbox from '../../Components/checkbox';
import { useContext, useEffect, useState } from 'react';
import '../ProfissionalEscolar/styles.css'
import CardCurso from '../../Components/CardCurso'
import api from '../../utils/api'
//usado para a validação dos forms
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Loading from '../../Components/Loading';

import { cepMask, ClearMask, onlyNumber } from '../../utils/mask';
import apiAux from '../../utils/apiAux';
import MessagePopUp from '../../Components/messagePopUp';
import { IsContains, IsNone } from '../../utils/functions';
import InfoForm from '../../Components/infoForm';
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { profissionalJson } from '../../utils/objectJson';
import { validationForm2, hiringRegimeVerify } from '../../utils/validationProfessional';
import { useIndexedLabels } from '../../utils/useIndexedLabels';
import { DataUtilsContext } from '../../context/dataUtils';


function ProfissionalDadosPessoais() {
  const {
    getTitleIndex,
    getIndexByLabel,
  } = useIndexedLabels();
  const [messageRequired, setMessageRequired] = useState([])
  let person = sessionStorage.getItem('ProfissionalSelecionado')
  const [removeLoad, setRemoveLoad] = useState(true)
  const [curso, setCurso] = useState({
    "code": 0,
    "conclusionYear": 0,
    "institutionName": "",
    "courseName": "",
    "higherEducationInstitution": 0,
    "codeEmployee": ""
  })
  const [posGraduacao, setPosGraduacao] = useState({
    "area": 0,
    "areaName": "",
    "conclusionYear": 0,
    "deleted": false,
    "type": 0,
    "codeEmployee": 0,
    "typeName": ""
  })
  const [listaDisciplinasAux, setListaDisciplinasAux] = useState([])
  const [auxIes, setAuxIes] = useState([]);
  const [modal, setModal] = useState(false)
  const [modalPosGraduacao, setModalPos] = useState(false)
  const navigation = useNavigate();
  const [uf, setUf] = useState('AC')
  const [erro, setErro] = useState(false)
  const { setErrorMessage } = useContext(MessageContext);

  const [DadosPessoais, setDadosPessoais] = useState(profissionalJson)
  const [CityDetails, setCityDetails] = useState('')
  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(validationForm2)
  });

  const {
    listUf,
    listIes,
    listHigherCourses,
    listPostgraduations,
    listKnowledgeAreas } = useContext(DataUtilsContext);



  const onSubmit = (data) => {

    let inep = sessionStorage.getItem('inep')
    setDadosPessoais({ ...DadosPessoais, inepRelation: inep })
    setRemoveLoad(false)
    let dados = DadosPessoais
    dados.cep = ClearMask(dados.cep)
    dados.inepRelation = inep
    dados.wasChanged = true

    sessionStorage.setItem('ProfissionalEditar', JSON.stringify(dados))
    api.put('/professional/', dados).then((response) => {

      setRemoveLoad(true)
      setErrorMessage([{ message: "Profissinal Atualizado com sucesso", ok: true }])
      sessionStorage.removeItem('quantCurrentIndexFields')
      navigation('/profissional/pesquisar', { replace: true })
    }).catch(errors => {
      setRemoveLoad(true)
      setErrorMessage([{ message: "Erro ao atualizar profissional", ok: false }])
    })

    // O valor é representado em milisegundos.
  };

  useEffect(() => {
    let Profissional = JSON.parse(sessionStorage.getItem('ProfissionalEditar'))
    setDadosPessoais(Profissional)
  

  }, [])


  // usar funcções para resolver isso do useEffect

  useEffect(() => {
    let test = cepMask(DadosPessoais.cep)
    if (test?.length === 9) {
      apiAux.get(test + '/json/').then(function (response) {
        setCityDetails(response.data)

        setDadosPessoais({
          ...DadosPessoais, uf: response.data.uf,
          cityResidence: response.data.ibge
        })
      })

    }
  }, [DadosPessoais.cep])

  useEffect(() => {
    const Filtrados = listIes.filter((ies) => ies.state.startsWith(uf))
    setAuxIes(Filtrados)
  }, [uf])

  function handleModal() {

    setModal(!modal)
  }
  function handleModalPosgraducao() {


    setModalPos(!modalPosGraduacao)
  }
  function deleteCurso(id) {
    let teste = DadosPessoais.courses
    let courses = teste.filter(item => item.id !== id)
    api.delete('/course/' + id).then(() => {
      setDadosPessoais({ ...DadosPessoais, courses })
      setErrorMessage([{ message: 'Curso deletada com sucesso', ok: true }])
      setValue("course[0]", 0)
    }).catch(() => {
      setErrorMessage([{ message: 'Erro ao deletar curso', ok: false }])
    })

  }

  function deletePosGraduacao(id) {
    let teste = DadosPessoais.postGraduations
    let postGraduations = teste.filter(item => item.code !== id)
    api.delete('/postgraduation/' + id).then(() => {
      setErrorMessage([{ message: 'Pós gradução deletada com sucesso', ok: true }])
      setDadosPessoais({ ...DadosPessoais, postGraduations })

    }).catch(() => {
      setErrorMessage([{ message: 'Erro ao deletar Pós graduação', ok: false }])
    })


  }
  function addCurso() {
    setErro(false)
    curso.codeEmployee = person
    if (curso.higherEducationInstitution !== 0 && curso.conclusionYear !== 0 && curso.courseName !== 0) {
      api.post('/course/', curso).then((res) => {
        setErrorMessage([{ message: 'Curso adicionada com sucesso', ok: true }])
        setDadosPessoais({
          ...DadosPessoais, courses: [
            ...DadosPessoais.courses,
            res.data
          ]
        })
      }).catch(() => {
        setErrorMessage([{ message: 'Erro ao adicionar curso', ok: false }])
      })
      setModal(false)
    }
    else {
      setErro(true)
    }
  }
  function addPosGraducao() {
    setErro(false)
    posGraduacao.codeEmployee = person
    if (posGraduacao.conclusionYear !== 0 && posGraduacao.type !== 0 && posGraduacao.area !== 0) {
      api.post('/postgraduation/', posGraduacao).then((res) => {
        setErrorMessage([{ message: 'Pós graduação adicionada com sucesso', ok: true }])
        setDadosPessoais({
          ...DadosPessoais, postGraduations: [
            ...DadosPessoais.postGraduations,
            res.data
          ]
        })
      }).catch(() => {
        setErrorMessage([{ message: 'Erro ao adicionar Pós graduação', ok: false }])
      })
      setModalPos(false)
    }
    else {
      setErro(true)
    }
  }
  console.log('validations:', errors)

  function filterDisciplinas() {
    let aux = listKnowledgeAreas.map((e) => {
      if (IsContains(e.code, DadosPessoais.knowledgeAreas)) {
        e.selected = true
        return e
      }
      else {
        e.selected = false
        return e
      }

    })
    setListaDisciplinasAux(aux)

  }

  useEffect(() => {
    filterDisciplinas()
  }, [DadosPessoais.knowledgeAreas, listKnowledgeAreas])


  function SelectComplementary() {
    let value = []
    value.push(
      <div style={{ marginTop: '10px' }} key={Math.random() + Math.random(1 * 10) + 'CA'}>
        <Label>
          Disciplina {1} <Madatory>*</Madatory>:
        </Label>
        <Select
          name='knowledgeArea[0]'
          {...setValue('knowledgeArea[0]', DadosPessoais.knowledgeAreas?.code1) ?? 0}
          value={DadosPessoais.knowledgeAreas?.code1 ?? 0}
          {...register('knowledgeArea[0]')}
          onChange={e => setDadosPessoais({
            ...DadosPessoais, knowledgeAreas: {
              ...DadosPessoais.knowledgeAreas,
              code1: Number(e.target.value)
            }
          })}>
          <Option key={Math.random() + 'KAPD'} value={0} disabled hidden>Selecione</Option>
          {listaDisciplinasAux.length > 0 ? listaDisciplinasAux.map((item, index) => {
            return <option key={index + item.name} value={item.code} disabled={item?.selected} >{item.name}</option>
          }) : ''}
        </Select>
      </div>
    )
    if (DadosPessoais.knowledgeAreas?.code1) {
      for (let x = 1; x < 25; x++) {
        if (DadosPessoais.knowledgeAreas[0] > 0 || DadosPessoais.knowledgeAreas['code' + x] > 0) {
          value.push(
            <div style={{ marginTop: '10px' }} key={Math.random() + Math.random(1 * 10) + 'CA'}>
              <Label>
                Disciplina {x + 1}:
              </Label>
              <Select
                name={`knowledgeArea[${x}]`}
                {...setValue(`knowledgeArea[${x}]`, DadosPessoais.knowledgeAreas[`code${x + 1}`] ?? 0)}
                value={(DadosPessoais.knowledgeAreas[`code${x + 1}`]) ?? 0}
                {...register(`knowledgeArea[${x}]`)}
                onChange={e => setDadosPessoais({
                  ...DadosPessoais, knowledgeAreas: {
                    ...DadosPessoais.knowledgeAreas,
                    [`code${x + 1}`]: Number(e.target.value)
                  }
                })}>
                <Option key={'KAP' + 0} value={0} disabled hidden>Selecione</Option>
                {listaDisciplinasAux.length > 0 ? listaDisciplinasAux.map((item, index) => {
                  return <option key={index + item.name} disabled={item?.selected} value={item.code} >{item.name}</option>
                }) : ''}

              </Select>
            </div>
          )
        }
      }
      if (value.length > 0) {
        return value
      }
      else {
        return <></>
      }
    }
    return value
  }

  useEffect(() => {
    if (errors) {
      const entries = Object.entries(errors).map(([key, error]) => ({
        id: key + '-' + error.message,
        fieldName: key,
        error,
      }));
      setMessageRequired(entries);
    }
  }, [errors]);

  console.log(DadosPessoais.courses)
  return (
    <>
      {!removeLoad && <Loading />}
      {/* inicio do modal curso*/}
      <div className='span-message'>
        {messageRequired.map(({ id, fieldName, error }) => {
          const idx = getIndexByLabel(fieldName) || "";
          const text = error.message;

          return (
            <MessagePopUp
              key={id}
              title={`Campo ${idx} - obrigatório`}
              text={text}
              onClose={() =>
                setMessageRequired(prev => prev.filter(m => m.id !== id))
              }
            />
          );
        })}
      </div>
      <div className='modal' onClick={e => { handleModal() }} style={{ display: modal ? 'flex' : 'none' }}>
        <div className='container-curso' onClick={e => { e.stopPropagation() }} >
          <div className='cc'>
            <div className='headModal'>
              <TitleFieldForm>
                Formulário para cadastro de Curso Superior
              </TitleFieldForm>
            </div>
            <div className='button-close'>
              <Button title="fechar" type='button' onClick={(e) => handleModal(e)} style={{ backgroundColor: 'red', width: '120px', height: '40px' }} />
            </div>
          </div>
          <div className='box-curso'>
            <TitleFieldForm>Curso superior <Madatory>*</Madatory></TitleFieldForm>
            <Select
              id='curs'
              name='curso'
              defaultValue={0}
              register={register('curso')}
              onChange={(e) => setCurso({ ...curso, code: e.target.value, courseName: document.getElementById(e.target.value).innerText })}
            >
              <Option value={0} disabled hidden>selecione</Option>
              {listHigherCourses.map((item, index) => {
                return <option key={index + item.name} id={item.id} value={item.id}>{item.name}</option>
              })}
            </Select>
          </div>
          <div className='box-curso2' style={{ marginTop: 20 }}>
            <div style={{ marginLeft: 20 }}>
              <TitleFieldForm>UF</TitleFieldForm>
              <Select
                style={{ width: 80 }}
                defaultValue={0}
                onChange={(e) => setUf(e.target.value)}
              >
                <option value={0} key={'CSPRO'}>Selecione</option>
                {listUf.map((item, index) => {
                  return <option key={index + item} value={item}>{item}</option>
                })}
              </Select>
            </div>
            <InputResponsive1 maxlength='4' value={onlyNumber(curso.conclusionYear)} mandatory='*' onChange={(e) => setCurso({ ...curso, conclusionYear: Number(e.target.value) })} style={{ width: 100 }} title='Ano de conclusão' />

          </div>
          <div className='box-curso'>
            <TitleFieldForm>Instituição de ensino superior <Madatory>*</Madatory></TitleFieldForm>
            <Select
              defaultValue={-1}
              onChange={(e) => setCurso({ ...curso, higherEducationInstitution: Number(e.target.value), institutionName: document.getElementById(e.target.value).innerText })}>
              <Option value={-1} disabled hidden>selecione</Option>
              {auxIes.map((item, index) => {
                return <option key={index + item.name} id={item.id} value={item.id}>{item.name}</option>
              })}
            </Select>
          </div>
          <div className='message-curso' style={{ color: 'red', display: erro ? 'block' : 'none' }}>Informe os campos obrigatório</div>
          <div className='button-salvar'>
            <Button type='button' title="Adicionar" onClick={() => addCurso()} style={{ backgroundColor: 'green', width: '120px', height: '40px', marginTop: '10px' }} />
          </div>
        </div>
      </div>
      {/* inicio do modal posGraduacao*/}
      <div className='modal' onClick={() => handleModalPosgraducao()} style={{ display: modalPosGraduacao ? 'flex' : 'none' }}>
        <div className='container-curso' onClick={e => { e.stopPropagation() }}>
          <div className='cc'>
            <div className='headModal'>
              <TitleFieldForm>Formulário de Pós-graduação</TitleFieldForm>
            </div>
            <div className='button-close'>
              <Button title="fechar" type='button' onClick={(e) => handleModalPosgraducao(e)} style={{ backgroundColor: 'red', width: '120px', height: '40px' }} />
            </div>
          </div>
          <div className='box-curso'>
            <TitleFieldForm>Área</TitleFieldForm>
            <Select
              defaultValue={0}
              onChange={(e) => setPosGraduacao({ ...posGraduacao, index: posGraduacao.index + 1, area: e.target.value, areaName: document.getElementById(e.target.value).innerText })}
            >
              <Option value={0} disabled hidden>selecione</Option>
              {listPostgraduations.map((item, index) => {
                return <option key={item.code + item.area} id={item.id} value={item.id}>{item.area}</option>
              })}
            </Select>
          </div>
          <div className='box-curso2' style={{ marginTop: 20, marginLeft: 35 }}>
            <InputResponsive1 maxlength='4' value={onlyNumber(posGraduacao.conclusionYear)} onChange={(e) => setPosGraduacao({ ...posGraduacao, conclusionYear: Number(e.target.value) })} style={{ width: 100 }} title='Ano de conclusão' />
          </div>
          <div className='box-curso'>
            <TitleFieldForm>Tipo de Pós graduação</TitleFieldForm>
            <Select
              defaultValue={0}
              onChange={(e) => setPosGraduacao({ ...posGraduacao, type: Number(e.target.value) })}>
              <option key={'0TPS'} value={0} disabled hidden>selecione</option>
              <option key={'1TPS'} value={1}>Especialização</option>
              <option key={'2TPS'} value={2}>Mestrado</option>
              <option key={'3TPS'} value={3}>Doutorado</option>
            </Select>
          </div>
          <div className='message-curso' style={{ color: 'red', display: erro ? 'block' : 'none' }}>Informe os campos obrigatório</div>
          <div className='button-salvar'>
            <Button type='button' title="Adicionar" onClick={() => addPosGraducao()} style={{ backgroundColor: 'green', width: '120px', height: '40px', marginTop: '10px' }} />
          </div>
        </div>
      </div>
      <App >
        <Container>
          <InfoForm
            title="Profissional"
            wasChanged={DadosPessoais.wasChanged}
            subtitle="Dados Pessoais"
            positionPagination="2/2"
          />
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormContent>
              <TextLabel>
                Endereço residencial
              </TextLabel>
              <Box>
                <TitleFieldForm>
                  {getTitleIndex("Pais de residência", 'countryResidence')} <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='countryResidence'
                  {...register('contryResidence')}
                  {...setValue('countryResidence', DadosPessoais.countryResidence)}
                  value={DadosPessoais.countryResidence ?? -1}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, countryResidence: Number(e.target.value) })}>
                  <Option value={-1} disabled hidden>selecione</Option>
                  <Option value={32}>Argentina</Option>
                  <Option value={68}>Bolívia</Option>
                  <Option value={76}>Brasil</Option>
                  <Option value={170}>Colômbia</Option>
                  <Option value={328}>Guiana</Option>
                  <Option value={254}>Guiana Francesa</Option>
                  <Option value={600}>Paraguai</Option>
                  <Option value={604}>Peru</Option>
                  <Option value={740}>Suriname</Option>
                  <Option value={604}>Uruguai</Option>
                  <Option value={604}>Venezuela</Option>
                </Select>
                <Message>{errors.countryResidence?.message}</Message>
              </Box>
              <Box style={{ display: DadosPessoais.countryResidence === 76 ? null : 'none' }}>

                <InputResponsive1 title={getTitleIndex("CEP", 'cep', DadosPessoais.countryResidence === 76)}
                  name="cep"
                  maxlength='9'
                  {...setValue('cep', cepMask(DadosPessoais.cep) ?? 0)}
                  register={register("cep")}
                  value={cepMask(DadosPessoais.cep) ?? 0}
                  erro={errors.cep?.message}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, cep: e.target.value })}
                />
              </Box>

              <Box2Items style={{ display: DadosPessoais.countryResidence === 76 ? null : 'none' }}>
                <Box50>
                  <TitleFieldForm>
                    {getTitleIndex("UF", 'uf', DadosPessoais.countryResidence === 76)}
                  </TitleFieldForm>
                  <Select
                    name='uf'
                    {...register('uf')}
                    disabled
                    value={CityDetails.uf ?? 0}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, uf: Number(e.target.value) })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    <option >{CityDetails.uf}</option>
                  </Select>
                  <Message>{errors.uf?.message}</Message>
                </Box50>
                <Box50>
                  <TitleFieldForm>
                    {getTitleIndex("Município", 'cityResidence', DadosPessoais.countryResidence === 76)}
                  </TitleFieldForm>
                  <Select
                    {...register('cityResidence')}
                    disabled
                    {...setValue('cityResidence', DadosPessoais.cityResidence ?? 0)}
                    value={DadosPessoais.cityResidence ?? 0}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, cityResidence: Number(e.target.value) })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option value={CityDetails.id} key={CityDetails.id}>{CityDetails.localidade}</Option>
                  </Select>
                  <Message>{errors.cityResidence?.message}</Message>
                </Box50>
              </Box2Items>
              <BoxInput>
                <TitleFieldForm>
                  {getTitleIndex("Localização/ Zona de residência", 'areaResidence')}
                </TitleFieldForm>
                <Box>
                  <Select
                    name='areaResidence'
                    {...register('areaResidence')}
                    {...setValue('areaResidence', DadosPessoais.areaResidence)}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, areaResidence: Number(e.target.value) })}
                  >
                    <Option key={'0ar'} value={0} disabled hidden>selecione</Option>
                    <Option key={'1ar'} value={1} > Urbana</Option>
                    <Option key={'2ar'} value={2}> Rural</Option>
                  </Select>
                  <Message>{errors.areaResidence?.message}</Message>
                </Box>
              </BoxInput>

              <Box>
                <TextLabel>
                  Dados variáreis
                </TextLabel>
                <TitleFieldForm>
                  {getTitleIndex("Escolaridade", 'educationLevel')} <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='educationLevel'
                  {...register('educationLevel')}
                  {...setValue('educationLevel', DadosPessoais.educationLevel)}
                  onChange={e => setDadosPessoais({ ...DadosPessoais, educationLevel: Number(e.target.value) })} >
                  <Option key={'0ev'} value={0} disabled hidden>selecione</Option>
                  <Option key={'6ev'} value={6} >Educação Superior</Option>
                  <Option key={'7ev'} value={7}>Ensino Médio</Option>
                  <Option key={'2ev'} value={2}>Ensino Fundamental</Option>
                  <Option key={'1ev'} value={1}>Não concluiu o ensino fundamental</Option>
                </Select>
                <Message>{errors.educationLevel?.message}</Message>
                <Box style={{ display: DadosPessoais.educationLevel > 2 ? 'flex' : 'none' }}>
                  <TitleFieldForm>
                    {/*colocado agora*/}
                    {getTitleIndex("Tipo de ensino médio cursado", 'typeHighSchool', DadosPessoais.educationLevel > 2)} <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name='typeHighSchool'
                    {...register('typeHighSchool')}
                    {...setValue('typeHighSchool', DadosPessoais.typeHighSchool)}
                    onChange={e => setDadosPessoais({ ...DadosPessoais, typeHighSchool: Number(e.target.value) })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    <Option key={'0th'} value={1} >Formação geral</Option>
                    <Option key={'1th'} value={2} >Modalidade normal/magistério</Option>
                    <Option key={'3th'} value={3} >Curso Técnico</Option>
                    <Option key={'4th'} value={4} >Magistério indígena - modalidade normal</Option>
                  </Select>
                  <Message>{errors.typeHighSchool?.message}</Message>
                </Box>
                <Box style={{ display: DadosPessoais.educationLevel === 6 ? 'flex' : 'none' }} >
                  <BoxColunm>
                    <TitleFieldForm>
                      {getTitleIndex("Curso superior", 'course', DadosPessoais.educationLevel === 6)}
                    </TitleFieldForm>
                    <button type='button' className='button-modal-pro' onClick={(e) => handleModal(e)}>
                      Adicionar curso
                    </button>
                  </BoxColunm>
                  <Message>{errors.course?.message}</Message>
                  <div className='card-curso'>
                    {!DadosPessoais.courses?.length || 0 ? "" : DadosPessoais.courses.map((item, index) => {
                      return (
                        <CardCurso
                          name={`course[0]`}
                          register={register(`course[0]`)}
                          setValue={setValue(`course[0]`, item)}
                          type='button'
                          onClick={(e) => deleteCurso(item.id)}
                          curso={item.code + " - " + item.courseName}
                          code={item.code + " - " + item.institutionName} ano={item.conclusionYear} />
                      )
                    })
                    }
                  </div>

                  <Box>
                    <TitleFieldForm>
                      {getTitleIndex("Possui pós-graduação?", 'noHavePostGraduation')}
                    </TitleFieldForm>
                    <Select
                      name='noHavePostGraduation'
                      {...register('noHavePostGraduation')}
                      {...setValue('noHavePostGraduation', DadosPessoais.noHavePostGraduation ?? 1)}
                      onChange={(e) => setDadosPessoais({
                        ...DadosPessoais, noHavePostGraduation: Number(e.target.value)
                      })}
                    >
                      <Option value={0}>Sim</Option>
                      <Option value={1} >Não</Option>
                    </Select>
                  </Box>
                  {DadosPessoais.courses?.length !== 0 ? <>
                    <BoxColunm style={{ display: DadosPessoais.noHavePostGraduation === 0 ? 'flex' : 'none' }} >
                      <TitleFieldForm>
                        Pós-graduação concluidas:

                      </TitleFieldForm>
                      <button type='button' className='button-modal-pro' onClick={() => handleModalPosgraducao()}>
                        Adicionar Pós-Graduação
                      </button>
                    </BoxColunm>
                    <Message>{errors?.postGraduation?.message}</Message>
                    {DadosPessoais.postGraduations?.map((item, index) => {
                      if (!item.deleted) {
                        return (
                          <div key={index + item.code} className='card-curso'>
                            <CardCurso
                              name={`postGraduation[0]`}
                              register={register(`postGraduation[0]`)}
                              setValue={setValue(`postGraduation[0]`, item)}
                              pos={item.areaName}
                              ano={item.conclusionYear}
                              typePos={item.type}
                              type='button'
                              key={index + item.code}
                              onClick={() => deletePosGraduacao(item.code)}
                            />

                          </div>
                        )

                      }
                      return (<> </>)
                    })}
                  </> : ""
                  }
                </Box>
              </Box>

              <Box2Items style={{ display: DadosPessoais.educationLevel === 6 ? 'flex' : 'none' }} >
                <TitleFieldForm>
                  {getTitleIndex("Formação/Complementação pedagógica", 'pedagogicalComplementations', DadosPessoais.educationLevel === 6)}
                </TitleFieldForm>
                <Box>
                  <Label>
                    Área do conhecimento/componente curricular 1
                  </Label>
                  <Select
                    name='pedagogicalComplementations[0]'
                    {...register('pedagogicalComplementations[0]')}
                    {...setValue('pedagogicalComplementations[0]', DadosPessoais.pedagogicalComplementations.component1)}
                    onChange={(e) => setDadosPessoais({
                      ...DadosPessoais, pedagogicalComplementations: {
                        ...DadosPessoais.pedagogicalComplementations,
                        component1: e.target.value
                      }
                    })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    {
                      listKnowledgeAreas.map((item) => {
                        return <option key={item.code + item.name} value={item.code} >{item.name}</option>
                      })
                    }
                  </Select>
                  <Label>
                    Área do conhecimento/componente curricular 2
                  </Label>
                  <Select
                    name='pedagogicalComplementations[1]'
                    {...register('pedagogicalComplementations[1]')}
                    {...setValue('pedagogicalComplementations[1]', DadosPessoais.pedagogicalComplementations.component2)}
                    onChange={(e) => setDadosPessoais({
                      ...DadosPessoais, pedagogicalComplementations: {
                        ...DadosPessoais.pedagogicalComplementations,
                        component2: e.target.value
                      }
                    })}
                  >
                    <Option value={0} disabled hidden>selecione</Option>
                    {listKnowledgeAreas.map((item) => {
                      return <option key={item.code + item.name} value={item.code} >{item.name}</option>
                    })}
                  </Select>
                  <Label>
                    Área do conhecimento/componente curricular 3
                  </Label>
                  <Select
                    name='pedagogicalComplementations[2]'
                    {...register('pedagogicalComplementations[2]')}
                    {...setValue('pedagogicalComplementations[2]', DadosPessoais.pedagogicalComplementations.component3)}
                    onChange={(e) => setDadosPessoais({
                      ...DadosPessoais, pedagogicalComplementations: {
                        ...DadosPessoais.pedagogicalComplementations,
                        component3: e.target.value
                      }
                    })} >
                    <Option value={0} disabled hidden>selecione</Option>
                    {listKnowledgeAreas.map((item, index) => {
                      return <option key={index + item.name} value={item.code} >{item.name}</option>
                    })}
                  </Select>
                </Box>
              </Box2Items>
              <Box2Items >
                <Box>
                  <TitleFieldForm>
                    {getTitleIndex("Função que exerce na turma", 'function')} <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Select
                    name='function'
                    {...register('function')}
                    {...setValue('function', DadosPessoais.function ?? 0)}
                    onChange={(e) => setDadosPessoais({
                      ...DadosPessoais, function: Number(e.target.value)
                    })}
                  >
                    <Option key={'0fp'} value={0} disabled hidden >selecione</Option>
                    <Option key={'1fp'} value={1} >Docente</Option>
                    <Option key={'5fp'} value={5} >Docente titular - coordenador de tutoria (de módulo ou disciplina) - EAD</Option>
                    <Option key={'6fp'} value={6} >Docente tutor - auxiliar (de módulo ou disciplina) - EAD</Option>
                    <Option key={'2fp'} value={2}>Auxiliar/assistente educacional</Option>
                    <Option key={'3fp'} value={3}>Profissional/monitor de atividade complementar</Option>
                    <Option key={'4fp'} value={4} >Tradutor e Intérprete de Libras</Option>
                    <Option key={'7fp'} value={7} >Guia-Intérprete</Option>
                    <Option key={'8fp'} value={8} >Profissional de apoio escolar para aluno(a)s com deficiência (Lei 13.146/2015)</Option>
                    <Option key={'9fp'} value={9} >Instrutor da Educação Profissional</Option>
                  </Select>
                </Box>
              </Box2Items>

              <Box2Items >
                <Box>
                  <TitleFieldForm>
                    {getTitleIndex("Outros cursos específicos (Fomação com no mínimo 80 horas)", 'especificFormations')} <Madatory>*</Madatory>
                  </TitleFieldForm>
                  <Message>{errors.especificFormations?.message}</Message>
                  <Checkbox title='Creche (0 a 3 anos)'
                    register={register('especificFormations[0]')}
                    name='especificFormations[0]'
                    setValue={setValue('especificFormations[0]', DadosPessoais.especificFormations.nursery)}
                    checked={DadosPessoais.especificFormations.nursery === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        nursery: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })} />
                  <Checkbox title='Pré-escolar (4 e 5 anos)'
                    register={register('especificFormations[1]')}
                    name='especificFormations[1]'
                    setValue={setValue('especificFormations[1]', DadosPessoais.especificFormations.preSchool)}
                    checked={DadosPessoais.especificFormations.preSchool === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        preSchool: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Anos iniciais do ensino fundamental'
                    register={register('especificFormations[2]')}
                    name='especificFormations[2]'
                    setValue={setValue('especificFormations[2]', DadosPessoais.especificFormations.elementaryEarlyYears)}
                    checked={DadosPessoais.especificFormations.elementaryEarlyYears === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        elementaryEarlyYears: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Anos finais do ensino fundamental'
                    register={register('especificFormations[3]')}
                    setValue={setValue('especificFormations[3]', DadosPessoais.especificFormations.finalYearsElementary)}
                    name='especificFormations[3]'
                    checked={DadosPessoais.especificFormations.finalYearsElementary === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        finalYearsElementary: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Ensino médio'
                    register={register('especificFormations[4]')}
                    name='especificFormations[4]'
                    setValue={setValue('especificFormations[4]', DadosPessoais.especificFormations.highSchool)}
                    checked={DadosPessoais.especificFormations.highSchool === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        highSchool: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação de jovens e adultos'
                    register={register('especificFormations[5]')}
                    name='especificFormations[5]'
                    setValue={setValue('especificFormations[5]', DadosPessoais.especificFormations.eja)}
                    checked={DadosPessoais.especificFormations.eja === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        eja: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação Especial'
                    register={register('especificFormations[6]')}
                    name='especificFormations[6]'
                    setValue={setValue('especificFormations[6]', DadosPessoais.especificFormations.specialEducation)}
                    checked={DadosPessoais.especificFormations.specialEducation === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        specialEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação Indígena'
                    register={register('especificFormations[7]')}
                    name='especificFormations[7]'
                    setValue={setValue('especificFormations[7]', DadosPessoais.especificFormations.indigenousEducation)}
                    checked={DadosPessoais.especificFormations.indigenousEducation === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        indigenousEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação do campo'
                    register={register('especificFormations[8]')}
                    name='especificFormations[8]'
                    setValue={setValue('especificFormations[8]', DadosPessoais.especificFormations.fieldEducation)}
                    checked={DadosPessoais.especificFormations.fieldEducation === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        fieldEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação ambiental'
                    register={register('especificFormations[9]')}
                    name='especificFormations[9]'
                    setValue={setValue('especificFormations[9]', DadosPessoais.especificFormations.environmentalEducation)}
                    checked={DadosPessoais.especificFormations.environmentalEducation === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        environmentalEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação em direitos humanos'
                    register={register('especificFormations[10]')}
                    name='especificFormations[10]'
                    setValue={setValue('especificFormations[10]', DadosPessoais.especificFormations.humanRightsEducation)}
                    checked={DadosPessoais.especificFormations.humanRightsEducation === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        humanRightsEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Gênero e diversidade sexual'
                    register={register('especificFormations[11]')}
                    name='especificFormations[11]'
                    setValue={setValue('especificFormations[11]', DadosPessoais.especificFormations.genderSexualDiversity)}
                    checked={DadosPessoais.especificFormations.genderSexualDiversity === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        genderSexualDiversity: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Direitos de criança e adolescente'
                    register={register('especificFormations[12]')}
                    name='especificFormations[12]'
                    setValue={setValue('especificFormations[12]', DadosPessoais.especificFormations.rightsChildrenAdolescents)}
                    checked={DadosPessoais.especificFormations.rightsChildrenAdolescents === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        rightsChildrenAdolescents: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação para as relações étnicorraciais e cultura Afro-Brasileira e Africana'
                    name='especificFormations[13]'
                    setValue={setValue('especificFormations[13]', DadosPessoais.especificFormations.ethnicCulturalEducation)}
                    checked={DadosPessoais.especificFormations.ethnicCulturalEducation === 1 ? true : false}
                    register={register('especificFormations[13]')}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        ethnicCulturalEducation: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação bilíngue de surdos'
                    register={register('especificFormations[14]')}
                    name='especificFormations[14]'
                    setValue={setValue('especificFormations[14]', DadosPessoais.especificFormations.bilingualEducationDeaf)}
                    checked={DadosPessoais.especificFormations.bilingualEducationDeaf === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        bilingualEducationDeaf: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Educação e Tecnologia de Informação e Comunicação (TIC)'
                    register={register('especificFormations[15]')}
                    name='especificFormations[15]'
                    setValue={setValue('especificFormations[15]', DadosPessoais.especificFormations.educationTIC)}
                    checked={DadosPessoais.especificFormations.educationTIC === 1 ? true : false}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        educationTIC: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Outros'
                    name='especificFormation[16]'
                    setValue={setValue('especificFormations[16]', DadosPessoais.especificFormations.others)}
                    checked={DadosPessoais.especificFormations.others === 1 ? true : false}
                    register={register('especificFormations[16]')}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations: {
                        ...DadosPessoais.especificFormations,
                        others: e.target.checked ? 1 : 0,
                        none: 0
                      }
                    })}
                  />
                  <Checkbox title='Nenhum'
                    name='especificFormations[15]'
                    setValue={setValue('especificFormations[15]', DadosPessoais.especificFormations.none)}
                    checked={DadosPessoais.especificFormations.none === 1 ? true : false}
                    register={register('especificFormations[15]')}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais, especificFormations:
                        IsNone(DadosPessoais.especificFormations, 'none')
                    })}
                  />
                </Box>
              </Box2Items>

              <Box style={{ display: [1, 5].includes(DadosPessoais.function) ? 'flex' : 'none' }} >
                <TitleFieldForm  >
                  {getTitleIndex("Áreas do conhecimento/componentes curriculares que leciona", 'knowledgeArea', [1, 5].includes(DadosPessoais.function))}<Madatory>*</Madatory>
                </TitleFieldForm>
                <SelectComplementary key={'KPE'} />
              </Box>
              <Box style={{ display: hiringRegimeVerify(DadosPessoais) }}>
                <TitleFieldForm>
                  {getTitleIndex("Situação funcional/regime de contratação/tipo de vínculo", 'functionSituation', hiringRegimeVerify(DadosPessoais))} <Madatory>*</Madatory>
                </TitleFieldForm>
                <Select
                  name='functionSituation'
                  {...register('functionSituation')}
                  {...setValue('functionSituation', DadosPessoais.hiringRegime ?? 0)}
                  onChange={(e) => setDadosPessoais({
                    ...DadosPessoais, hiringRegime: e.target.value
                  })}
                >
                  <Option key={'0fs'} value={0} disabled hidden>selecione</Option>
                  <Option key={'1fs'} value={1} >Concursado/efetivo/estável</Option>
                  <Option key={'2fs'} value={2}>Contrato temporário</Option>
                  <Option key={'3fs'} value={3}>Contrato terceirizado</Option>
                  <Option key={'4fs'} value={4} >Contrato CLT</Option>
                </Select>
              </Box>
              <Box2Items style={{ display: [1, 5].includes(DadosPessoais.function) ? 'flex' : 'none' }}>
                <Box>
                  <TitleFieldForm>
                    {getTitleIndex("Área(s) do itinerário formativo", 'areaItineraryFormative', [1, 5].includes(DadosPessoais.function))}
                  </TitleFieldForm>
                  <Message>{errors.areaItineraryFormative?.message}</Message>
                  <Checkbox

                    title='Linguagens e suas tecnologias'
                    name='areaItineraryFormative[languagesTechnologies]'
                    register={register('areaItineraryFormative[0]')}
                    setValue={setValue('areaItineraryFormative[0]', DadosPessoais.areaItineraryFormative?.languagesTechnologies ?? 0)}
                    checked={DadosPessoais.areaItineraryFormative?.languagesTechnologies === 1}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais,
                      areaItineraryFormative: {
                        ...DadosPessoais.areaItineraryFormative,
                        languagesTechnologies: e.target.checked ? 1 : 0
                      }
                    })}
                  />

                  <Checkbox
                    title='Matemática e suas tecnologias'
                    name='areaItineraryFormative[mathematicsTechnologies]'
                    register={register('areaItineraryFormative[1]')}
                    setValue={setValue('areaItineraryFormative[1]', DadosPessoais.areaItineraryFormative?.mathematicsTechnologies ?? 0)}
                    checked={DadosPessoais.areaItineraryFormative?.mathematicsTechnologies === 1}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais,
                      areaItineraryFormative: {
                        ...DadosPessoais.areaItineraryFormative,
                        mathematicsTechnologies: e.target.checked ? 1 : 0
                      }
                    })}
                  />

                  <Checkbox
                    title='Ciências da natureza e suas tecnologias'
                    name='areaItineraryFormative[scienceTechnologies]'
                    register={register('areaItineraryFormative[2]')}
                    setValue={setValue('areaItineraryFormative[2]', DadosPessoais.areaItineraryFormative?.scienceTechnologies ?? 0)}
                    checked={DadosPessoais.areaItineraryFormative?.scienceTechnologies === 1}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais,
                      areaItineraryFormative: {
                        ...DadosPessoais.areaItineraryFormative,
                        scienceTechnologies: e.target.checked ? 1 : 0
                      }
                    })}
                  />

                  <Checkbox
                    title='Ciências humanas e sociais aplicadas'
                    name='areaItineraryFormative[humanScience]'
                    register={register('areaItineraryFormative[3]')}
                    setValue={setValue('areaItineraryFormative[3]', DadosPessoais.areaItineraryFormative?.humanScience ?? 0)}
                    checked={DadosPessoais.areaItineraryFormative?.humanScience === 1}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais,
                      areaItineraryFormative: {
                        ...DadosPessoais.areaItineraryFormative,
                        humanScience: e.target.checked ? 1 : 0
                      }
                    })}
                  />
                  <Checkbox
                    title='Profissional escolar leciona no Itinerário de formação técnica e profissional (IFTP)'
                    name='areaItineraryFormative[IFTP]'
                    register={register('areaItineraryFormative[4]')}
                    setValue={setValue('areaItineraryFormative[4]', DadosPessoais.areaItineraryFormative?.IFTP ?? 0)}
                    checked={DadosPessoais.areaItineraryFormative?.IFTP === 1}
                    onChange={e => setDadosPessoais({
                      ...DadosPessoais,
                      areaItineraryFormative: {
                        ...DadosPessoais.areaItineraryFormative,
                        IFTP: e.target.checked ? 1 : 0
                      }
                    })}
                  />
                </Box>
              </Box2Items>
              <ButtonFormFooter
                textNext="Salvar"
                linkBack={"/profissional/editar-identificacao"}
              />
            </FormContent>
          </form>
        </Container>
      </App>
    </>
  )

}
export default ProfissionalDadosPessoais;